import { useNavigate } from 'react-router-dom';
import { Box, Container, Grid, Typography, Card, CardMedia, Link, useMediaQuery, Skeleton } from '@mui/material';
import { CATEGORY_IMAGES } from '../constants/categories';
import { createTheme } from '@mui/material/styles';
import LdPlaceHolder from '../assets/ldplaceholder.png';

const CategoriesHomePage = ({ popularCategories, loading = false }) => {
  const theme = createTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  const LoadingSkeleton = () => (
    <Grid container spacing={isMobile ? 0.5 : {xs: 0.5, md: 0.5, lg: 1}} sx={{
      width: 'auto',
      px: 0
    }}>
      {[...Array(8)].map((_, index) => (
        <Grid item xs={6} sm={3} md={3} lg={3} key={index} sx={{
          display: 'flex',
          width: isMobile ? '180px' : '24%',
          aspectRatio: !isMobile ? '1/1' : undefined,
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <Card sx={{ 
            width: isMobile ? '180px' : '100%',
            height: isMobile ? '180px' : '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            backgroundColor: '#fffbf0',
            borderRadius: '1px',
          }}>
            <Box sx={{ 
              height: '100%', 
              p: isMobile ? '4% 4% 0 4%' : '8% 8% 0 8%'
            }}>
              <Skeleton 
                variant="rectangular" 
                width="100%" 
                height="100%" 
                sx={{ 
                  bgcolor: 'rgba(0,0,0,0.1)',
                  borderRadius: '2px',
                }}
              />
            </Box>
            <Box sx={{ p: isMobile ? 1 : 2 }}>
              <Skeleton 
                variant="text" 
                width="70%" 
                height={isMobile ? 24 : 32}
                sx={{ 
                  bgcolor: 'rgba(0,0,0,0.1)',
                }}
              />
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  return <Box sx={{ pb: 1 }}>
    <Container sx={{
      width: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      mx: isMobile ? '6.5vw' : '11.5vw',
      pt:1,
      px:'0 !important'
    }}>
      
      {loading ? (
        <LoadingSkeleton />
      ) : (
        <Grid container spacing={isMobile ? 0.5 : {xs: 0.5, md: 0.5, lg: 1}} sx={{
          width: 'auto',
          px:0

        }}>
          {popularCategories.map((category) => (
            <Grid item xs={6} sm={3} md={3} lg={3} key={category} sx={{
              display: 'flex',
              width: isMobile ? '180px' : '24%',
              aspectRatio: !isMobile ? '1/1' : undefined,
              justifyContent: 'center',
              alignItems: 'center',
            }}>
              <Card 
                component={Link}
                onClick={() => navigate(`/s/?category=${category}`)}
                to={`/s/?category=${category}`}
                href={`/s/?category=${category}`}
                sx={{ 
                  width: isMobile ? '180px' : '100%',
                  height: isMobile ? '180px' : '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-end',
                  backgroundColor: '#fffbf0',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '1px',
                  '&:hover': {
                    cursor: 'pointer',
                    transform: 'scale(1.02)',
                    transition: 'transform 0.3s'
                  }
                }}
              >
                <CardMedia
                  component="img"
                  image={CATEGORY_IMAGES[category] || LdPlaceHolder}
                  alt={category}
                  sx={{
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: '2px',
                    p: isMobile ? '4% 4% 0 4%' : '8% 8% 0 8%'
                  }}
                />
                <Box sx={{ p: isMobile ? 1 : 2 }}>
                  <Typography 
                    variant={isMobile ? "body1" : "h6"} 
                    sx={{ 
                      color: 'black', 
                      fontWeight: 'bold',
                      fontSize: isMobile ? '0.9rem' : undefined
                    }}
                  >
                    {category}
                  </Typography>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  </Box>
}

export default CategoriesHomePage;